import { useMutation, useQuery } from 'react-query';
import { getApplicationById, getApplications, startApplication } from '~/api/aplications';
import { ApplicationById } from '~/types';

export const useGetApplications = (enabled?: boolean) => {
  return useQuery(['applications'], () => getApplications(), {
    enabled: !!enabled,
  });
};

export const useGetApplicationById = (id: string | undefined, enabled?: boolean) => {
  return useQuery(['application', id], () => getApplicationById(id!), {
    enabled: !!enabled && !!id,
  });
};

export const useStartApplication = (type: string, onSuccess?: (data: ApplicationById) => void) => {
  return useMutation(() => startApplication(type), {
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data);
      }
    },
  });
};
